import React from 'react';

const DocumentCenter = () => {
  const documents = [
    { name: 'Contrato de Servicios', type: 'Contrato', date: '2024-09-03' },
    { name: 'Propuesta de Proyecto', type: 'Propuesta', date: '2024-09-01' },
    { name: 'Reporte de Avances', type: 'Reporte', date: '2024-08-28' },
  ];

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-6">
      <h2 className="text-3xl font-bold mb-4">Centro de Documentación</h2>
      <ul>
        {documents.map((doc, index) => (
          <li key={index} className="border-b py-2">
            <strong>{doc.name}</strong> - {doc.type} - {doc.date}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DocumentCenter;
